export default {
  props: {
    validateType: {
      type: String,
      default: ''
    },
    range: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'datetime'
    },
    minTime: {
      type: [String, Number],
      default: 0
    },
    maxTime: {
      type: [String, Number],
      default: 0
    },
    value: null
  },
  data() {
    return {
      popup: false,
      minDate: null,
      maxDate: null,
      currentDate: null
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let min = this.minTime
      let max = this.maxTime
      let range = this.range
      let validateType = this.validateType
      if (validateType === 'relativeTime') {
        if (min) {
          min = Date.now() + Number(min) * 60 * 60 * 24 * 1000
        }
        if (range) {
          max = min + Number(range) * 60 * 60 * 24 * 1000
        }
      }
      if (!min) {
        let date = new Date()
        date.setFullYear(date.getFullYear() - 100)
        this.minDate = date
        date.getMinutes()
      } else {
        this.minDate = new Date(min)
      }
      if (!max) {
        let date = new Date()
        date.setFullYear(date.getFullYear() + 100)
        this.maxDate = date
      } else {
        this.maxDate = new Date(max)
      }
      if (Date.now() > this.maxDate.getTime()) {
        this.currentDate = this.maxDate
      } else if (Date.now() < this.minDate.getTime()) {
        this.currentDate = this.minDate
      } else {
        this.currentDate = new Date()
      }
    }
  }
}
